import { api } from '@/lib/api-client'

export interface SignInPayload {
  email: string
  password: string
}

export async function signIn(payload: SignInPayload): Promise<void> {
  await api.post('/api/auth/sign-in/email', payload)
}

export async function signOut(): Promise<void> {
  await api.post('/api/auth/sign-out')
}
